import React, { useContext } from 'react'
import { FormattedMessage } from 'react-intl'
import * as R from 'ramda'
import { NotificationAction } from './notificationContext/NotificationActionProvider'
import { makeStyles } from '@material-ui/core/styles'
import clsx from 'clsx'

const useStyles = makeStyles((theme) => ({
  expirationIcon: {
    color: '#fff',
    margin: '3px',
  },
  expirationDate: {
    color: theme.palette.primary.main,
  },
  expirationCancelButton: {
    color: theme.palette.secondary.main,
  },
  switchMaterial: {
    marginLeft: '-10px !important',
  },
  circleIcon: {
    width: '2rem',
    height: '2rem',
    background: '#F56570',
    borderRadius: '5px',
    position: 'absolute',
    zIndex: '-99',
  },
}))

const CancelExpirationButton = ({ messageExpiration }) => {
  const classes = useStyles()

  const notiAction = useContext(NotificationAction)
  const onClickCancel = () => {
    notiAction.cancelExpiration(messageExpiration)
  }
  if (!R.prop('hasExpiration', messageExpiration)) return null
  else
    return (
      <div className="w-full px-16 py-8 flex items-center">
        <div className="flex">
          <div className={classes.circleIcon} />
          <svg
            className={clsx(classes.expirationIcon, 'h-14 w-14 fill-current')}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
          >
            <path fill="none" d="M0 0h24v24H0z" />
            <path d="M15 2h-3.5l-1-1h-5l-1 1H1v2h14zM16 9c-.7 0-1.37.1-2 .29V5H2v12c0 1.1.9 2 2 2h5.68A6.999 6.999 0 0 0 23 16c0-3.87-3.13-7-7-7zm0 12c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z" />
            <path d="M16.5 12H15v5l3.6 2.1.8-1.2-2.9-1.7z" />
          </svg>
        </div>

        <span className={clsx(classes.expirationDate, 'ml-8 text-xs')}>
          {messageExpiration.expirationDate}
        </span>
        {R.prop('hasExpired', messageExpiration) ? null : (
          <button
            className={clsx(
              'pl-16 text-xs font-semibold hover:underline',
              classes.expirationCancelButton,
            )}
            onClick={onClickCancel}
          >
            <FormattedMessage id="notificationTimeline.card.messageExpiration.cancelExpiring" />
          </button>
        )}
      </div>
    )
}

export default React.memo(CancelExpirationButton)
